/**
 * DELETE-USERS.MODAL
 * Delete all users for one account
 */
import Modal from "@/components/modal"
import { connect } from "react-redux"
import { withTranslation, WithTranslation } from "react-i18next"
import { UserState } from "@/redux/user.types"
import { store } from "@/index"
import { userDestroyAll, userStatus } from "@/redux/user.actions"
import { STATUS_LOADING, STATUS_LOAD_ERROR } from "@/redux/_status.types"
import EnterCodeWidget from "@/widgets/enter-code.widget"
import PageLoader from "@/components/page-loader"
import { useState } from "react"
import Checkbox from "@/components/checkbox"

interface StateProps extends WithTranslation {
  user: UserState
}

interface OwnProps {
  onClose: Function
  onDeleteSuccess: Function
}

type Props = StateProps & OwnProps

function DeleteUsersModal(props: Props) {
  const { t } = props

  const [destroyAdmin, setDestroyAdmin] = useState<boolean>(false)

  //Proceed
  async function next() {
    store.dispatch(userStatus(STATUS_LOADING))

    const usersResponse: any = await store.dispatch(userDestroyAll(destroyAdmin))

    if (usersResponse.error) {
      store.dispatch(userStatus(STATUS_LOAD_ERROR))
    } else {
      props.onDeleteSuccess()
    }
  }

  return (
    <Modal onClose={props.onClose} title={t("users_delete")}>
      <PageLoader status={props.user.status}>
        <p>{t("users_delete_warning")}</p>
        <Checkbox active={destroyAdmin} onClick={() => setDestroyAdmin(!destroyAdmin)} text={t("keep_special_roles")} />
        <EnterCodeWidget onCancel={props.onClose} onNext={next} status={props.user.status} />
      </PageLoader>
    </Modal>
  )
}

const mapStateToProps = (state) => ({
  user: state.user
})

export default connect(mapStateToProps)(withTranslation()(DeleteUsersModal))
